import { PlaceSelectorComponent } from './place-selector.component';

export default angular
  .module('sfMobile.components.place-selector', ['sfMobile.services.log'])
  .component('sfPlaceSelector', PlaceSelectorComponent).name;
